var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUndrawTeamRe0Bfe(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 344,
    height: 338.564,
    viewBox: "0 0 344 338.564",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "undraw_team_re_0bfe",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_216",
    "data-name": "Elipse 216",
    cx: 50.267,
    cy: 50.267,
    r: 50.267,
    transform: "translate(0 115.445)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_217",
    "data-name": "Elipse 217",
    cx: 20.045,
    cy: 20.045,
    r: 20.045,
    transform: "translate(30.671 127.718)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_412",
    "data-name": "Trazado 412",
    d: "M312.989,118.331a50.137,50.137,0,1,1-14.622-35.608,50.267,50.267,0,0,1,14.622,35.608Z",
    transform: "translate(-212.182 -67.975)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_218",
    "data-name": "Elipse 218",
    cx: 50.267,
    cy: 50.267,
    r: 50.267,
    transform: "translate(119.282 115.445)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_219",
    "data-name": "Elipse 219",
    cx: 50.267,
    cy: 50.267,
    r: 50.267,
    transform: "translate(119.136 0)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_220",
    "data-name": "Elipse 220",
    cx: 50.267,
    cy: 50.267,
    r: 50.267,
    transform: "translate(241.649 0)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_221",
    "data-name": "Elipse 221",
    cx: 50.267,
    cy: 50.267,
    r: 50.267,
    transform: "translate(243.466 115.445)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_413",
    "data-name": "Trazado 413",
    d: "M312.989,655.411a50.045,50.045,0,1,1-14.657-35.61A50.267,50.267,0,0,1,312.989,655.411Z",
    transform: "translate(-212.182 -367.115)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_222",
    "data-name": "Elipse 222",
    cx: 50.267,
    cy: 50.267,
    r: 50.267,
    transform: "translate(122.367 238.029)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_414",
    "data-name": "Trazado 414",
    d: "M272.216,124.856c2.079-6.624,6.805-12.7,13.342-14.939s16.109,1.172,21.024,6.07c8.99,8.959,11.183,39.737,5.007,49.464-1.228-.065-5.467-.113-6.711-.16l-1.759-5.862v5.8q-2.971-.092-5.989-.127A26.065,26.065,0,0,1,271.4,139.684C271.236,133.233,271.4,127.466,272.216,124.856Z",
    transform: "translate(-244.975 -90.941)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_223",
    "data-name": "Elipse 223",
    cx: 14.326,
    cy: 14.326,
    r: 14.326,
    transform: "translate(35.468 27.218)",
    fill: "#9e616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_415",
    "data-name": "Trazado 415",
    d: "M296.311,122.955l16.495-8.259h0a20.732,20.732,0,0,1,12.143,17.177l.411,4.925-6.907-1.758-.757-6.3-1.173,5.806-3.188-.811.03-9.776-3.19,9.769-11.385-2.616Z",
    transform: "translate(-258.88 -93.993)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_224",
    "data-name": "Elipse 224",
    cx: 7.097,
    cy: 7.097,
    r: 7.097,
    transform: "translate(148.649 132.657)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_225",
    "data-name": "Elipse 225",
    cx: 17.979,
    cy: 17.979,
    r: 17.979,
    transform: "translate(149.122 137.861)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_226",
    "data-name": "Elipse 226",
    cx: 14.61,
    cy: 14.61,
    r: 14.61,
    transform: "translate(153.979 144.595)",
    fill: "#9e616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_416",
    "data-name": "Trazado 416",
    d: "M582.713,390.576a16.735,16.735,0,0,0-25.443,14.605c7.444,1.869,15.265,3.3,23.2.447l1.875-4.589,1.105,4.592c2.418.988,4.842,1.824,7.266-.01A17.087,17.087,0,0,0,582.713,390.576Z",
    transform: "translate(-404.202 -246.264)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_417",
    "data-name": "Trazado 417",
    d: "M520.582,338.4a14.517,14.517,0,0,0-15.151,2.334,16.419,16.419,0,0,0-5.24,14.612c.8,5.448,4.117,10.14,7.17,14.724s6.036,9.607,6.033,15.114a14.982,14.982,0,0,1-14.952,14.973c4.656,2,9.515,4.048,14.578,3.81s10.37-3.493,11.2-8.494c.6-3.6-1.173-7.117-2.647-10.459a73.977,73.977,0,0,1-5.17-17.02c-.492-2.8-.813-5.738.1-8.427a9.9,9.9,0,0,1,9.831-6.494L528,351.567A13.024,13.024,0,0,0,520.582,338.4Z",
    transform: "translate(-371.443 -217.91)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_418",
    "data-name": "Trazado 418",
    d: "M817.753,121.546a47.232,47.232,0,0,1-3.37,10.755c-8.867,18.758,16.385,12.644,25.409,12.644,9.867,0,19.307,5.188,17.865-17.865-.616-9.847-8-17.865-17.865-17.865C831.364,109.215,819.515,112.961,817.753,121.546Z",
    transform: "translate(-546.351 -90.941)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_227",
    "data-name": "Elipse 227",
    cx: 14.517,
    cy: 14.517,
    r: 14.517,
    transform: "translate(277.445 24.965)",
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_419",
    "data-name": "Trazado 419",
    d: "M838.465,120.626a16.629,16.629,0,0,1,25.282,14.513c-7.4,1.857-15.169,3.279-23.058.444l-1.863-4.56-1.1,4.563c-2.4.982-4.811,1.813-7.22-.009a16.979,16.979,0,0,1,7.956-14.951Z",
    transform: "translate(-556.361 -95.942)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_228",
    "data-name": "Elipse 228",
    cx: 17.907,
    cy: 17.907,
    r: 17.907,
    transform: "translate(32.817 134.627)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "ab6171fa-7d69-4734-b81c-8dff60f9761b",
    cx: 15.25,
    cy: 15.25,
    r: 15.25,
    transform: "translate(156.277 263.011)",
    fill: "#9e616a"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_229",
    "data-name": "Elipse 229",
    cx: 16.391,
    cy: 16.391,
    r: 16.391,
    transform: "translate(155.061 22.612)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bf427902-b9bf-4946-b5d7-5c1c7e04535e",
    d: "M589.137,115.774s4.268-8.159-5.121-8.9c0,0-8-7.261-16.163-1.327,0,0-4.45,0-6.884,5.036,0,0-3.5-1.327-4.269,2.225,0,0-2.561,7.417,0,14.092s3.412,7.417,3.412,7.417-1.8-8.284,8.447-9.025,19.641-7.159,20.495,1,1.792,4.473,1.792,4.473S598.953,119.112,589.137,115.774Z",
    transform: "translate(-403.253 -87.599)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_230",
    "data-name": "Elipse 230",
    cx: 16.046,
    cy: 16.046,
    r: 16.046,
    transform: "translate(276.3 139.848)",
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_420",
    "data-name": "Trazado 420",
    d: "M313.024,662.635h0l-.249.448c2.214-5.456.2-12.179-3.749-16.293s-9.439-5.995-14.845-6.741a24.113,24.113,0,0,0-11.995.932c-5.526,2.129-9.748,7.057-13.273,12.183-1.612,2.345-3.2,5.018-3.037,7.948.149,2.72,1.763,5.028,3.085,7.335s2.426,5.17,1.477,7.689a15.1,15.1,0,0,1-2.73,3.809c-.97,1.228-1.767,2.887-1.3,4.427a3.612,3.612,0,0,0,2.691,2.339,9.516,9.516,0,0,0,3.575-.085l30.814-4.656a13.132,13.132,0,0,0,9.532-19.337Z",
    transform: "translate(-241.926 -386.367)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_231",
    "data-name": "Elipse 231",
    cx: 15.066,
    cy: 15.066,
    r: 15.066,
    transform: "translate(30.894 292.782) rotate(-80.783)",
    fill: "#ffb9b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_421",
    "data-name": "Trazado 421",
    d: "M322.692,766.8a50.249,50.249,0,0,1-70.327,5.083l4.312-12.031a12.938,12.938,0,0,1,10.989-7.546l2.743-.168,6.54-5.641s17.623-.629,17.361-.931l10.675,6.421-.009-.044,4.2.257a12.932,12.932,0,0,1,10.989,7.546Z",
    transform: "translate(-234.408 -445.314)",
    fill: "#58b957"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_422",
    "data-name": "Trazado 422",
    d: "M596.692,766.8a50.25,50.25,0,0,1-70.327,5.083l4.312-12.031a12.938,12.938,0,0,1,10.989-7.546l2.743-.168,6.54-5.641s17.623-.629,17.361-.931l10.675,6.421-.009-.044,4.2.257a12.932,12.932,0,0,1,10.989,7.546Z",
    transform: "translate(-386.994 -445.314)",
    fill: "#58b957"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_423",
    "data-name": "Trazado 423",
    d: "M309.351,663.089c-.389-2.057-2.487-3-4.285-3.454a41.277,41.277,0,0,0-15.968-.877c-3.885.554-7.862,1.776-10.68,4.808a14.364,14.364,0,0,0-3.632,9.251,11.016,11.016,0,0,0,1.319,5.877,5.446,5.446,0,0,0,4.528,2.918l.181.629A27.425,27.425,0,0,0,299.828,669.5a16.318,16.318,0,0,1-4.767,7.7,29.7,29.7,0,0,0,12.823-9.882C308.778,666.136,309.647,664.655,309.351,663.089Z",
    transform: "translate(-246.884 -396.747)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_424",
    "data-name": "Trazado 424",
    d: "M321.692,489.8a50.25,50.25,0,0,1-70.327,5.083l4.312-12.031a12.937,12.937,0,0,1,10.989-7.546l2.743-.168,6.54-5.641s17.623-.629,17.361-.931l10.675,6.421-.009-.044,4.2.257a12.932,12.932,0,0,1,10.989,7.546Z",
    transform: "translate(-233.851 -291.057)",
    fill: "#58b957"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_425",
    "data-name": "Trazado 425",
    d: "M591.442,491.159a50.249,50.249,0,0,1-70.327,5.083l4.311-12.031a12.938,12.938,0,0,1,10.989-7.546l2.743-.168,6.54-5.641s17.623-.629,17.361-.931l10.675,6.421-.009-.044,4.2.257a12.932,12.932,0,0,1,10.989,7.546Z",
    transform: "translate(-384.07 -291.814)",
    fill: "#58b957"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_426",
    "data-name": "Trazado 426",
    d: "M871.442,491.159a50.25,50.25,0,0,1-70.327,5.083l4.312-12.031a12.937,12.937,0,0,1,10.989-7.546l2.743-.168,6.54-5.641s17.623-.629,17.361-.931l10.675,6.421-.009-.044,4.2.257a12.932,12.932,0,0,1,10.989,7.546Z",
    transform: "translate(-539.998 -291.814)",
    fill: "#58b957"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_427",
    "data-name": "Trazado 427",
    d: "M321.692,229.8a50.25,50.25,0,0,1-70.327,5.083l4.312-12.031a12.937,12.937,0,0,1,10.989-7.546l2.743-.168,6.54-5.641s17.623-.629,17.361-.931l10.675,6.421-.009-.044,4.2.257a12.932,12.932,0,0,1,10.989,7.546Z",
    transform: "translate(-233.851 -146.267)",
    fill: "#58b957"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_428",
    "data-name": "Trazado 428",
    d: "M590.442,230.159a50.25,50.25,0,0,1-70.327,5.083l4.312-12.031a12.938,12.938,0,0,1,10.989-7.546l2.743-.168,6.54-5.641s17.623-.629,17.361-.931l10.675,6.421-.009-.044,4.2.257a12.932,12.932,0,0,1,10.989,7.546Z",
    transform: "translate(-383.513 -146.468)",
    fill: "#58b957"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_429",
    "data-name": "Trazado 429",
    d: "M870.442,230.159a50.25,50.25,0,0,1-70.327,5.083l4.312-12.031a12.938,12.938,0,0,1,10.989-7.546l2.743-.168,6.54-5.641s17.623-.629,17.361-.931l10.675,6.421-.009-.044,4.2.257a12.932,12.932,0,0,1,10.989,7.546Z",
    transform: "translate(-539.441 -146.468)",
    fill: "#58b957"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_430",
    "data-name": "Trazado 430",
    d: "M867.638,379.283a20.687,20.687,0,0,0-8.664-11.787c-3.369-2.155-7.572-3.255-11.389-2.115s-6.976,4.885-6.726,8.932a3.915,3.915,0,0,0-3.952,1.22,9.06,9.06,0,0,0-1.939,3.926,24.959,24.959,0,0,0,.234,13.821l-.076.645c1.862-.308,3.274-1.906,4.152-3.608s1.384-3.59,2.335-5.251,2.532-3.142,4.418-3.193l-.166,2.882,4.867-2.507-1.158,2.769,4.25-1.776-.475,2.663a6.324,6.324,0,0,1,8.706-2.815,8.4,8.4,0,0,1,3.435,4.833,25.458,25.458,0,0,1,.823,6.031A21.092,21.092,0,0,0,867.638,379.283Z",
    transform: "translate(-558.37 -233.341)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_431",
    "data-name": "Trazado 431",
    d: "M567.329,711.532c-.03-.083-.057-.168-.087-.251-.059.052-.115.105-.179.153Z",
    transform: "translate(-409.658 -426.221)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_432",
    "data-name": "Trazado 432",
    d: "M596.146,663.2a10.963,10.963,0,0,0-4.094-8,9.618,9.618,0,0,1-2.505-2.265,15.5,15.5,0,0,1-.851-2.122c-1.171-2.786-4.507-4.267-7.5-3.845a11.268,11.268,0,0,0-7.327,4.9,4.987,4.987,0,0,0-6.974,5.781c-1.55-1.249-4.057-.25-5.024,1.489s-.814,3.867-.526,5.837a55.144,55.144,0,0,0,2.592,10.449c1.509-1.329,1.416-3.749,1.232-5.795-.192-2.125-.077-4.72,1.782-5.769,1.8-1.013,3.975.1,5.955.675a11.254,11.254,0,0,0,9.309-1.464,29.32,29.32,0,0,1,3.061-2.133,3.613,3.613,0,0,1,3.562-.063,4.976,4.976,0,0,1,1.651,2.9l2.287,7.755a10.964,10.964,0,0,0,3.373-8.332Z",
    transform: "translate(-406.351 -390.367)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_433",
    "data-name": "Trazado 433",
    d: "M318.24,371.954a39.621,39.621,0,0,0,.173-4.022,18.933,18.933,0,0,0-1.428-7.752,11.912,11.912,0,0,0-6.233-6.022,11.373,11.373,0,0,0-8.527.007,17.175,17.175,0,0,0-8.1-2.949,9.058,9.058,0,0,0-7.721,3.277,12.6,12.6,0,0,1-1.349,1.753c-1.431,1.325-3.6,1.134-5.506.863l2.559,2.193-3.1.809,3.614,2.192c-3.5,2.1-5.087,6.682-4.667,10.843.4,3.94,2.3,7.543,4.573,10.745.907-1.914.712-4.2.7-6.361a14.393,14.393,0,0,1,.128-2.091c7.685,1.842,15.714,3.024,23.858.1l1.634-4,.688.07.947,3.933c2.146.877,4.3,1.644,6.449.838.1.608.168,1.228.216,1.823.185-.713.345-1.431.489-2.152a6.357,6.357,0,0,0,.815-.52,17.505,17.505,0,0,0-.212-3.578Z",
    transform: "translate(-248.623 -225.7)",
    fill: "#2f2e41"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndrawTeamRe0Bfe);
export default __webpack_public_path__ + "static/media/undraw_team_re_0bfe.c5698044418e73a2ae03111b349f02ad.svg";
export { ForwardRef as ReactComponent };